module.exports = __webpack_public_path__ + "static/media/lock-red-big.c98e73c1.svg";